import { createSelector } from 'reselect';

import { offersCountTooltipSelector } from '../root/offersCountTooltipSelector';

export const offersCountTooltipTargetSelector = createSelector(
  offersCountTooltipSelector,
  offersCountTooltip => offersCountTooltip.target,
);
